
// type it
export const sortBlocksDecending = ([skuA]: string[], [skuB]: string[]) => {
    const monthA = skuA.slice(0, 3);
    const monthB = skuB.slice(0, 3);
    const yearA = Number(skuA.slice(-4));
    const yearB = Number(skuB.slice(-4));
    const monthOrder = [
        'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
        'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
    ].reverse(); // Reverse for descending order
    if (yearA !== yearB) {
        return yearB - yearA;
    }
    return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
}
